<div class="coordinator-detail">
    <div class="coordinator-top-area">
        <h2>
            <mat-icon>person</mat-icon>{{doctorName}}
        </h2>
        <div class="button-area">
            <button class="edit" *ngIf="buttonDispaly && editarBtn" (click)="onEdit()" type="button">Editar</button>
            <button class="update" *ngIf="buttonDispaly && guardarBtn" (click)="onSave()" type="button">Guardar</button>
            <button class="delete" *ngIf="buttonDispaly && cancelarBtn" (click)="onCancel()" type="button">Cancelar</button>
            <button class="delete" *ngIf="buttonDispaly && eliminarBtn" (click)="onDelete()"type="button">Eliminar</button>
        </div>
    </div>
    <div class="block-looper middle" *ngIf="doctorInputFeilds">
        <form class="form" role="form" autocomplete="off" [formGroup]="coordinatorsForm">
            <!-- <h2>Fields</h2> -->
            <div class="form-wrap long-width">
                <mat-label>Nombre</mat-label>
                <mat-form-field class="example-full-width" appearance="fill">
                    <input formControlName="doctorName" maxlength="50"  matInput type="text">
                </mat-form-field>
                <!-- <mat-error class="m-t--15">
                    <span class="validation-span font-88">El nombre es obligatorio</span>
                </mat-error> -->
            </div>
            <div class="form-wrap short-width" *ngIf="fijoMesShow">
                <mat-label>Fijo mes</mat-label>
                <mat-form-field class="example-full-width" appearance="fill">
                    <input matInput type="text"  formControlName="fijoMes" class="curr" appSpanishNumber >
                    <span  matSuffix>&nbsp;€</span >
                </mat-form-field>
                <mat-error class="fix-err" *ngIf="coordinatorsForm.get('fijoMes').invalid && coordinatorsForm.get('fijoMes').touched">
                    <span *ngIf="coordinatorsForm.get('fijoMes').errors.hasTwoDecimalPlaces">
                     Invalido formato
                    </span>
                </mat-error>
            </div> 
        </form>
    </div>
    <div class="block-looper" *ngIf="despachosInputFeilds">
        <h2>Despachos <button mat-icon-button (click)="addEditCoordinator(null)"><mat-icon>add</mat-icon></button></h2>
        <div class="year-selector">
            <button (click)="yearMin()" mat-icon-button><mat-icon>keyboard_arrow_left</mat-icon></button>
            <span>{{year}}</span>
            <button (click)="yearMax()" mat-icon-button><mat-icon>keyboard_arrow_right</mat-icon></button>
        </div>
        <div class="agenda-loop-wrapper">
            <div class="agenda-loop" *ngFor="let item of despachosDataSource">
                <p>
                    <span>{{item.realizada |date: 'dd/MM/yyyy'}}</span>
                    <button class="more" [matMenuTriggerFor]="moreMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                     
                    <mat-menu #moreMenu="matMenu" [overlapTrigger]="false">
                        <a>
                            <button (click)="addEditCoordinatorDrop(item)" mat-menu-item>
                                <mat-icon>edit</mat-icon>
                                <span>Editar</span>
                            </button>
                        </a>
                        <a>
                            <button (click)="onDeleteDrop(item)" mat-menu-item>
                                <mat-icon>delete_forever</mat-icon>
                                <span>Eliminar</span>
                            </button>
                        </a>
                    </mat-menu>
                </p>
                <p>{{item.comentarios}}</p>
            </div>
            
        </div>
    </div>
</div>